module.exports = __webpack_public_path__ + "img/about-1-570x350.84fbbd34.jpg";